"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrokenAlertAttributeFilterInfo = exports.isBrokenAlertDateFilterInfo = void 0;
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Tests whether the provided object is an instance of {@link BrokenAlertDateFilterInfo}
 *
 * @param item - object to test
 *
 * @alpha
 */
function isBrokenAlertDateFilterInfo(item) {
    return sdk_model_1.isDashboardDateFilter(item.alertFilter);
}
exports.isBrokenAlertDateFilterInfo = isBrokenAlertDateFilterInfo;
/**
 * Tests whether the provided object is an instance of {@link BrokenAlertAttributeFilterInfo}
 *
 * @param item - object to test
 *
 * @alpha
 */
function isBrokenAlertAttributeFilterInfo(item) {
    return sdk_model_1.isDashboardAttributeFilter(item.alertFilter);
}
exports.isBrokenAlertAttributeFilterInfo = isBrokenAlertAttributeFilterInfo;
//# sourceMappingURL=alertTypes.js.map